// Контакты направлений. Фото консультанта: файл в assets/photos или null (будет монограмма).
import rustamPhoto from "../assets/photos/rustam.webp";
import vugarPhoto from "../assets/photos/vugar.webp";

export const OFFICES = {
  dubai: {
    key: "rustam",
    phone: "+971 50 739 3139",
    whatsapp: "971507393139",
    instagram: "rustaminvestments",
    photo: rustamPhoto,
    initials: "RA",
  },
  istanbul: {
    key: "vugar",
    phone: "+90 536 724 97 24",
    whatsapp: "905367249724",
    instagram: "turkiye_emlak",
    photo: vugarPhoto,
    initials: "VA",
  },
};

// Общий Instagram компании
export const COMPANY_INSTAGRAM = "rrconsulting_tr";

export const waLink = (office, text) =>
  `https://wa.me/${office.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const igLink = (office) => `https://instagram.com/${office.instagram}`;

// Направление объекта → чей контакт показывать
export const officeFor = (country) => (country === "uae" ? OFFICES.dubai : OFFICES.istanbul);
